module.exports = __webpack_public_path__ + "static/media/Eid Mnemonics-05.6f06522a.jpg";